const resolutions = {
	480: 640,
	720: 1280,
	1080: 1920,
	2160: 3840,
};

const deviceKindInactiveMap = {
	audioinput: {
		deviceId: 'mic_off',
		label: 'mic off',
	},
	videoinput: {
		deviceId: 'cam_off',
		label: 'cam off',
	},
	audiooutput: {
		label: 'default',
		deviceId: 'default',
	},
};

const gridViewBackgrounds = [
	'radial-gradient(75.4% 75.4% at 50% 50%, #A5AFFF 0%, #4E5FDC 100%)',
	'radial-gradient(75.4% 75.4% at 50% 50%, #A883FF 0%, #7963AB 100%)',
	'radial-gradient(75.4% 75.4% at 50% 50%, #939ABF 0%, #384796 100%)',
	'radial-gradient(75.4% 75.4% at 50% 50%, #D6A2D3 0%, #B56FB2 100%)',
	'radial-gradient(75.4% 75.4% at 50% 50%, #B48158 0%, #8A562C 100%)',
	'radial-gradient(75.4% 75.4% at 50% 50%, #A3BED8 0%, #4F83B3 100%)',
	'radial-gradient(75.4% 75.4% at 50% 50%, #CA7075 0%, #91343A 100%)',
	'radial-gradient(75.4% 75.4% at 50% 50%, #D0A892 0%, #DC8557 100%)',
	'radial-gradient(75.4% 75.4% at 50% 50%, #94A2FF 0%, #515B96 100%)',
	'radial-gradient(75.4% 75.4% at 50% 50%, #6FA497 0%, #146655 100%)',
	'radial-gradient(75.4% 75.4% at 50% 50%, #CFBF94 0%, #B0913E 100%)',
	'radial-gradient(75.4% 75.4% at 50% 50%, #504DC7 0%, #282675 100%)',
];

const riversideBackgrounds = [
	'waves',
	'yellow-pink',
	'yellow-purple',
	'black-gradient',
	'black-purple',
	'colorful',
	'dark-pink',
	'purple-gradient',
	'riverside-purple',
];

export { resolutions, deviceKindInactiveMap, gridViewBackgrounds, riversideBackgrounds };
